<div class="chatWrapper">
  <!--<div class="aiChatTitleBar">
    <p-dropdown
      [options]="aiBots"
      [(ngModel)]="selectedAiBot"
      placeholder="Select"
      optionLabel="name"
      optionValue="code"
      styleClass="chatBotDrop"
    ></p-dropdown>
  </div>-->
  <div class="newChatPrompts" *ngIf="!messages.length">
    <div class="welcomeTxt">
      <h3 class="d-flex align-items-center justify-content-center">
        <img src="/assets/images/ai/wave-hand.gif" alt="Waving Hand" width="48" class="mr-3" />
        Hello, Social Media Star!
      </h3>
      <p>
        I'm your personal Confe.ioAI assistant, here to help with content ideas, engagement
        strategies, and more! <br />
        Need a customized AI assistant? Click <strong>+</strong> to create one!
      </p>
    </div>

    <div class="recomend d-flex align-items-center">
      <p class="mr-2">Suggested AI Assistants:</p>
      <p-button
        icon="pi pi-sync"
        label="Refresh Suggestions"
        size="small"
        (click)="shufflePrompts()"
      />
    </div>

    <ul class="list-unstyled">
      <li *ngFor="let prompt of displayedPrompts">
        <div class="img">
          <img src="/assets/images/ai/prompt.png" alt="{{ prompt.title }}" />
        </div>
        <div (click)="sendMessage(prompt.description)" class="textInput">
          <h4>{{ prompt.title }}</h4>
          <p>{{ prompt.description }}</p>
        </div>
      </li>
    </ul>
  </div>

  <div *ngIf="messages.length" class="aiInboxContent" #scrollPanelRef>
    <div *ngFor="let message of messages">
      <div *ngIf="message.role === 'assistant'" class="aiAssistant">
        <div class="asstWrap">
          <div class="chatSnap">
            <img src="/assets/images/logo/confe-icon.png" alt="Assistant" />
          </div>
          <div class="messageText">
            <div class="name mb-2">
              <strong> AI bot </strong>
            </div>
            <markdown class="variable-binding" [data]="message.content"></markdown>
            <div class="bottomBtns d-flex justify-content-end">
              <!-- <p-button icon="pi pi-sync" [rounded]="true" [text]="true" />-->
              <p-button icon="pi pi-copy" [rounded]="true" [text]="true" />
              <p-button icon="pi pi-share-alt" [rounded]="true" [text]="true" />
              <!--<p-button icon="pi pi-ellipsis-v" [rounded]="true" [text]="true" />-->
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="message.role === 'user'" class="aiChatBlock">
        <div class="chatSnap">
          <p-avatar
            label="P"
            shape="circle"
            [style]="{ 'background-color': '#5854d1', color: '#ffffff' }"
          />
        </div>
        <div class="messageText">
          <div class="name mb-2">
            <strong> You </strong>
          </div>
          <p [innerHTML]="message.content"></p>
        </div>
      </div>

      <div *ngIf="message.role === 'typing'" class="aiAssistant">
        <div class="asstWrap">
          <div class="chatSnap">
            <img src="/assets/images/logo/confe-icon.png" alt="Assistant" />
          </div>
          <div class="messageText">
            <div class="name mb-2">
              <strong> Kiwi bot </strong>
            </div>
            <p>...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="textInput"
    *ngIf="!messages.length; else hasMessages"
    [class.newChatInputText]="!messages.length"
  >
    <app-ai-ask (getUserInput)="sendMessage($event)"></app-ai-ask>
  </div>
  <ng-template #hasMessages>
    <div class="textInput">
      <app-ai-ask (getUserInput)="sendMessage($event)"></app-ai-ask>
    </div>
  </ng-template>
</div>
